export const returnToApp = () => {
        window.location.replace('walkingmonth://main')
}
